// Models
import { SLICE_NAME } from "app/store/pagesToolbar/pagesToolbar.models";
// ToDO
import PageActions from "app/store/page/page.actions";
// End: ToDO
import { PagesToolbarActions } from "app/store/pagesToolbar/pagesToolbar.slice";
// Utils
import { $post } from "app/utilities/HttpClient";
import asyncThunkHandler from "app/utilities/AsyncThunkHandler";

const _url:string = '/dms/documents';

export const rotatePage = asyncThunkHandler(
  `${SLICE_NAME}/Rotate page`,
  async ({ documentId, pageNum, data }:{ documentId:number, pageNum:number, data:any }, { dispatch }) => {
    const response:Response = await $post(`${_url}/${documentId}/pages/${pageNum}/actions/rotate`, data);
    const page = await response.json();
    // ToDO
    dispatch(PageActions.rotatePageSuccess(page));
    // End: ToDO
    return page;
  }
);

export const rotatePages = asyncThunkHandler(
  `${SLICE_NAME}/Rotate pages`,
  async (pages:any[], { dispatch }) => {
    const CHUNK_SIZE = 5;
    const pageChunks = chunkArray(pages, CHUNK_SIZE);
    const allResponses = [];
    for ( const chunkedPages of pageChunks ){
      const responses = await Promise.all(
        chunkedPages.map(async (page) => {
          const { documentId, pageNum, ...restData } = page;
          const response: Response = await $post(`${_url}/${documentId}/pages/${pageNum}/actions/rotate`, restData);
          const p = await response.json();
          // ToDO
          dispatch(PageActions.rotatePageSuccess(p));
          // End: ToDO
          dispatch(PagesToolbarActions.removeLoadingPage({ documentId, pageNum }));
          return p;
        })
      );
      allResponses.push(...responses);
    }
  }
);

// 
function chunkArray<T>(arr: T[], size: number): T[][] {
  const chunks: T[][] = [];
  for (let i = 0; i < arr.length; i += size) {
    chunks.push(arr.slice(i, i + size));
  }
  return chunks;
}